"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AphroditeRebalanced = void 0;
var Tags_1 = require("../../Tags");
var Resources_1 = require("../../../Resources");
var Card_1 = require("../../Card");
var CardName_1 = require("../../../CardName");
var CardType_1 = require("../../CardType");
var CardRenderer_1 = require("../../render/CardRenderer");
var Phase_1 = require("../../../Phase");
var GainResources_1 = require("../../../deferredActions/GainResources");
var AphroditeRebalanced = (function (_super) {
    __extends(AphroditeRebalanced, _super);
    function AphroditeRebalanced() {
        return _super.call(this, {
            name: CardName_1.CardName.APHRODITE_REBALANCED,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.VENUS],
            startingMegaCredits: 50,
            cardType: CardType_1.CardType.CORPORATION,
            metadata: {
                cardNumber: 'R01',
                description: 'You start with 2 plant production, and 50 M€.',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.br;
                    b.production(function (pb) { return pb.plants(2); }).nbsp.megacredits(50);
                    b.corpBox('effect', function (ce) {
                        ce.effect('Whenever Venus is terraformed 1 step, you gain 3 M€ and the player (not WGT) who raised it gain 2 M€', function (eb) {
                            eb.venus(1).any.startEffect;
                            eb.megacredits(2).any.asterix().nbsp.megacredits(3);
                        });
                    });
                }),
            },
        }) || this;
    }
    AphroditeRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.PLANTS, 2);
        return undefined;
    };
    AphroditeRebalanced.rebalancedAphroditeBonus = function (venusRaiser, stepsRaised) {
        if (stepsRaised === void 0) { stepsRaised = 1; }
        var rebalancedAphroditePlayer = venusRaiser.game.getPlayers().find(function (player) { return player.isCorporation(CardName_1.CardName.APHRODITE_REBALANCED); });
        if (rebalancedAphroditePlayer === undefined)
            return 0;
        return (rebalancedAphroditePlayer.id === venusRaiser.id) ? 5 * stepsRaised : 2 * stepsRaised;
    };
    AphroditeRebalanced.onVenusIncrease = function (venusRaiser, venusStep) {
        if (venusStep === void 0) { venusStep = 1; }
        var aphroditePlayer = venusRaiser.game.getCardPlayer(CardName_1.CardName.APHRODITE_REBALANCED);
        aphroditePlayer.game.defer(new GainResources_1.GainResources(aphroditePlayer, Resources_1.Resources.MEGACREDITS, {
            count: 3 * venusStep,
            cb: function () { return aphroditePlayer.game.log('${0} gained ${1} ${2} from ${3}\'s ability.', function (b) { return b.player(aphroditePlayer).number(3 * venusStep).string(Resources_1.Resources.MEGACREDITS).cardName(CardName_1.CardName.APHRODITE_REBALANCED); }); },
        }), -1);
        if (venusRaiser.game.phase === Phase_1.Phase.ACTION || venusRaiser.game.phase === Phase_1.Phase.PRELUDES) {
            venusRaiser.game.defer(new GainResources_1.GainResources(venusRaiser, Resources_1.Resources.MEGACREDITS, {
                count: 2 * venusStep,
                cb: function () { return venusRaiser.game.log('${0} gained ${1} ${2} from ${3}\'s ability.', function (b) { return b.player(venusRaiser).number(2 * venusStep).string(Resources_1.Resources.MEGACREDITS).cardName(CardName_1.CardName.APHRODITE_REBALANCED); }); },
            }), -1);
        }
    };
    return AphroditeRebalanced;
}(Card_1.Card));
exports.AphroditeRebalanced = AphroditeRebalanced;
//# sourceMappingURL=AphroditeRebalanced.js.map